import { Text } from "@chakra-ui/react";
import { BiSushi } from "react-icons/bi";
import {
  FaBurger,
  FaInstagram,
  FaLinkedin,
  FaPizzaSlice,
  FaTelegram,
} from "react-icons/fa6";
import { GiNoodles } from "react-icons/gi";
import { GiDonerKebab } from "react-icons/gi";
import { LuSoup } from "react-icons/lu";
import { FaBoxesStacked } from "react-icons/fa6";

import { GiCook, GiSushis, GiFruitBowl } from "react-icons/gi";
import { TbTruckDelivery } from "react-icons/tb";
import aboutImage1 from "../Assets/Image/aboutImage1.jpg";
import aboutImage2 from "../Assets/Image/aboutimage2.jpg";
import bg from "../Assets/Image/bg.jpg";
import bg2 from "../Assets/Image/bg2.jpg";
import bg3 from "../Assets/Image/bg3.jpg";
import pepsi from "../Assets/Image/pepsicola.webp";
import vilenas from "../Assets/Image/vilenas.webp";
import watatsumi from "../Assets/Image/wata.webp";

export const PartnersData = [
  {
    image: pepsi,
  },
  {
    image: vilenas,
  },
  {
    image: watatsumi,
  },
];
export const BenefitData = [
  {
    icon: TbTruckDelivery,
    color: "#ec907e",
    title: "Быстрая доставка",
    mainText:
      "Кухни во всех районах города и свои курьеры обеспечивают максимальную скорость доставки",
  },
  {
    icon: GiFruitBowl,
    color: "#709f88",
    title: "Свежие продукты",
    mainText:
      "Используем для приготовления только самые качественные и свежие ингредиенты",
  },
  {
    icon: GiSushis,
    color: "#decb6a",
    title: "Акции и скидки",
    mainText: "Приятные расценки, наличие специальных акций и постояных скидок",
  },
  {
    icon: GiCook,
    color: "#8cb8e7",
    title: "Професиональное качество",
    mainText:
      "Работа с лучшими суши-мастерами и шеф-поварами, которые готовят на высшем уровне!",
  },
];
export const AboutData = [
  {
    image: aboutImage1,
    title: "Заказать суши от Burger Lord ",
    text: (
      <Text>
        Хотите приятно провести вечер или вкусно пообедать с коллегами?
        Заказывайте суши от Бургер Лорд домой или в офис. В меню нашего
        заведения вы найдете огромный выбор различных видов суши и роллов — от
        классических наименований с лососем или тунцом до оригинальных авторских
        проработок. Все блюда готовятся только из свежих ингредиентов, что
        гарантирует высокое качество и вкус каждого блюда. <br />
        <br /> Если вы хотите попробовать несколько разных видов суши, в Бургер
        Лорде есть возможность заказать специальный набор, в котором собраны
        лучшие топовые виды суши и роллов. Это отличный вариант для тех, кто
        хочет попробовать различные блюда японской кухни и оценить их вкус. На
        любимые блюда азиатской кухни у нас действуют скидки и акции, которыми
        рекомендуем воспользоваться. <br />
        <br />
        Заказать суши в Днепре можно онлайн или по телефону, не выходя из своей
        зоны комфорта. Работаем ежедневно и даже в праздники. У нас есть своя
        доставка суши в любой район Днепра.
      </Text>
    ),
  },
  {
    image: aboutImage2,
    title: "Доставка суши от Burger Lord: плюсы",
    text: (
      <Text>
        Доставка суши в Днепре — это удобный и быстрый способ получить свои
        изысканные деликатесы японской кухни прямо у себя дома или в офисе.
        Несколько плюсов, которые делают доставку суши в Днепре особенно
        выгодной:
        <br />
        <br /> Удобство и экономия времени. Не нужно тратить время на поездку в
        ресторан, выбор блюд и ожидание заказа. Все, что нужно — это выбрать
        нужные блюда в меню и сделать заказ по телефону или через интернет. Вам
        не нужно даже покидать свой дом или офис, доставка суши с доставкой по
        городу приедет к вам. Широкий выбор блюд. В Burger Lord можно найти
        огромный выбор блюд японской кухни. Вы можете выбрать любимые суши и
        роллы, а также попробовать что-то новое из меню. Качество и свежесть
        блюд. Готовим блюда только из свежих и качественных ингредиентов. Это
        гарантирует вкус каждого блюда. Доступность цен. Бесплатная доставка по
        городу. Возможность оформить заказ в любое время. <br />
        <br /> Таким образом, заказать суши на дом или в офис — это качественно,
        приятно и выгодно.
      </Text>
    ),
  },
];
export const MenuData = [
  {
    title: "Японская кухня в Днепре",
    image: bg,
    text: "Наши сушисты предлагают огромный выбор суши и роллов, которые покоряют харьковчан своим супер вкусом и внешним видом уже более 10 лет. В нашем меню суши полностью соответствуют японским традициям, а премиум роллы – американским. А еще можно попробовать суши-сеты со слабосоленым и копченым лососем, угрем и тунцом, с вкуснейшим морским окунем или икрой летучей рыбы.",
  },
  {
    title: " Меню европейской кухни",
    image: bg2,
    text: "Наша доставка предлагает вам великолепные блюда итальянской и разнообразной европейской кухни. Это конечно же пицца, пасты карбонара и с морепродуктами, шаурма, салаты с лососем, супы и многое другое. У нас есть всё для повседневного и праздничного застолья!",
  },
  {
    title: "Американские блюда",
    image: bg3,
    text: "Кто откажется от свежего и сочного бургера? Эта американская еда завоевала все континенты и страны. Вкусная котлетка с соусами и хрустящей булкой так и манит своим ароматом. Плох или хорош фаст-фуд? Об этом можно спорить долго. Но люди часто выбирают американские бургеры, потому что это — удобно, вкусно и быстро.",
  },
];
export const NavBarData = [
  {
    text: "Cуши",
    icon: GiSushis,
    router: "/sushi",
  },
  {
    text: "Роллы",
    icon: BiSushi,
    router: "/rolls",
  },
  {
    text: "Сеты",
    icon: FaBoxesStacked,
    router: "/sets",
  },
  {
    text: "Шаурма",
    icon: GiDonerKebab,
    router: "/kebab",
  },
  {
    text: "Лапша",
    icon: GiNoodles,
    router: "/noodles",
  },
  {
    text: "Супы",
    icon: LuSoup,
    router: "/soups",
  },
  {
    text: "Бургер",
    icon: FaBurger,
    router: "/burgers",
  },
  {
    text: "Пицца",
    icon: FaPizzaSlice,
    router: "/pizza",
  },
];
export const btmDescription = [
  {
    page: "Sushi",
    id: 1,
    title1: <Text>Настоящие суши в Днепре от Burger Lord</Text>,
    text1: (
      <Text>
        Азиатская кухня сейчас на пике своей популярности и только расширяет
        свой ассортимент блюд, которыми можно насладиться. Есть различные блюда,
        которые пришлись по душе украинцам, но более всего нравятся настоящие
        японские суши — самое популярное блюдо японской кухни. Готовятся из
        свежих ингредиентов с использованием правильного риса, приправленного
        рисовым уксусом и сахаром. В суши могут входить различные виды рыбы,
        морепродукты, овощи и фрукты. В Burger Lord мы предлагаем ассортимент
        суши, включающий классические и авторские интерпретации, которые готовы
        удивлять вкусовыми оттенками новичков и любителей. <br />
        <br /> В Burger Lord вы можете заказать вкусные суши на дом или в офис и
        получить гастрономическое удовольствие. У нас есть своя быстрая и
        качественная доставка в любой уголок города.
      </Text>
    ),
    title2: <Text>Свежайшие суши только из-под ножа</Text>,
    text2: (
      <Text>
        В Burger Lord мы готовим суши из-под ножа, чтобы наши клиенты могли
        насладиться аутентичным вкусом этого блюда. <br />
        <br />
        Наш опытный и профессиональный шеф-повар готовит каждый заказ вручную,
        для приготовления суши используются исключительно самые свежие и
        высококачественные продукты. В наших суши ничего лишнего — только рис и
        рыба, угорь или краб. Мы следим за качеством продуктов и поставляем их
        непосредственно от производителей, чтобы обеспечить максимальную
        свежесть. <br />
        <br /> Когда вы заказываете суши в Burger Lord, вы можете быть уверены,
        что ваш заказ будет приготовлен на месте и только после принятия вашего
        заказа, что гарантирует максимальное качество продукта. Мы используем
        только натуральные ингридиенты и не добавляем консерванты или
        искусственные ароматизаторы. <br />
        <br />У нас в меню вы найдете множество разнообразных видов суши — от
        классических до экзотических. Каждый наш ролл приготовлен с максимальной
        точностью и профессионализмом, чтобы удовлетворить ваши вкусовые
        предпочтения. <br />
        <br />
        Заказывая в Burger Lord вы насладитесь настоящим вкусом свежайших суши,
        приготовленных из-под ножа нашими опытными поварами!
      </Text>
    ),
  },
  {
    page: "Rolls",
    id: 2,
    title1: <Text>Доставка роллов по городу Днепр</Text>,
    text1: (
      <Text>
        Ищите вкусные роллы? А еще хотите, чтобы они были доставлены домой или в
        офис в считанные минуты? Тогда мы рады предложить вам доставку роллов по
        городу Днепр! Мы готовим свежие роллы из качественных ингредиентов и
        привозим их домой или в офис. <br />
        <br />У нас в меню есть разнообразный ассортимент роллов, в том числе
        классические роллы с лососем и авокадо, фирменные роллы с креветкой и
        огурцом, а также вегетарианские роллы с авокадо и огурцом по
        традиционным рецептам. <br />
        <br /> Мы работаем каждый день с 10:00 до 21:00 и принимаем заказы по
        телефону или через наш сайт. Если нужна помощь в выборе, то наши
        специалисты вам помогут, не стесняйтесь спрашивать. У нас вы можете
        указать желаемое время доставки ваших роллов или же мы доставим роллы
        Днепр быстро и качественно домой или в офис в течении 60-90 минут с
        момента оформления заказа.
      </Text>
    ),
    title2: <Text>Лучшие ингредиенты для вкуснейших роллов</Text>,
    text2: (
      <Text>
        Для роллов используем самые свежие составляющие. Придерживаемся высоких
        стандартов качества при выборе ингредиентов для наших роллов. <br />
        <br />
        Первый и, пожалуй, самый важный ингредиент — это рис. Мы используем
        только качественный рис японского производства, который обладает
        идеальной структурой и текстурой.
        <br />
        <br /> Далее, мы выбираем только свежие овощи и фрукты для начинки.
        Например, мы используем только свежий авокадо, который мы выбираем с
        особой тщательностью, чтобы он был не только качественным, но и идеально
        спелым. Также мы используем только свежий огурец, помидор и другие
        овощи. <br />
        <br />В роллах от Burger Lord исключтельно свежие морепродукты. Среди
        которых лучшие креветки, лосось и другие виды рыбы, качество которых
        контролируется перед тем, как использовать для приготовления японских
        вкусностей. <br />
        <br />
        Для того, чтобы придать роллам уникальный вкус и аромат дополняем их
        классическими и авторским соусами. <br />
        <br />
        Мы готовим вкусные роллы с большой любовью и уважением к нашим клиентам,
        поэтому вы можете быть уверены в качестве и свежести наших ингредиентов.
        Заказать свежие роллы в Днепре можно уже сегодня.
      </Text>
    ),
  },
  {
    page: "Sets",
    id: 3,
    title1: <Text>Доставка суши-сетов в Днепре</Text>,
    text1: (
      <Text>
        Если вы ищете вкусные и качественные суши сеты в Днепре, то мы рады
        предложить вам наш сервис доставки от Burger Lord. Мы готовы доставить
        вам самые свежие и вкусные суши наборы, приготовленные профессиональными
        поварами, прямо к вашей двери дома или офиса.
        <br />
        <br /> Мы предлагаем ассортимент суши сетов, от классических роллов до
        комбинаций с экзотическими ингредиентами. Мы используем только
        качественные и свежие продукты, чтобы гарантировать вам идеальный вкус и
        текстуру каждого блюда. <br />
        <br />
        Наши цены конкурентоспособны, а доставка суши сетов в Днепре самая
        лучшая и быстрая. Вы можете заказать у нас суши сеты на любой вкус и для
        любого повода — от обычного ужина до большого мероприятия. В меню
        представлены вкусные сеты для маленькой или большой компании, есть
        варианты для двоих. Выбирайте и заказывайте, что вам ближе. Заказать
        суши сет в Днепре с доставкой можно по телефону или онлайн.
      </Text>
    ),
    title2: <Text>Почему стоит выбрать сет суши?</Text>,
    text2: (
      <Text>
        Сет суши — это отличный выбор для тех, кто хочет попробовать различные
        виды суши, не затратив при этом много времени на выбор и заказ каждого
        блюда отдельно. <br />
        <br />
        Набор суши представляет собой комбинацию нескольких видов суши, которые
        тщательно подобраны по калориям и составлены в одном сете. Это позволяет
        наслаждаться различными вкусами и текстурами. <br />
        <br />
        Кроме того, заказывая сет суши, вы можете быть уверены в качестве и
        свежести каждого блюда. Ведь все ингредиенты для сетов суши готовятся
        непосредственно перед заказом, что гарантирует их свежесть и вкусность.
        <br />
        <br />
        Сеты суши также отличный выбор для различных мероприятий, таких как
        вечеринки или корпоративные мероприятия, где гости могут наслаждаться
        разнообразием вкусов, при этом каждый найдет для себя идеальное
        сочетание. А доставка сетов на дом или офис не заставит себя долго
        ждать. Привезем в любой район города или в центр. <br />
        <br />
        И, конечно же, заказ сета суши является более экономичным вариантом, по
        сравнению с заказом отдельных блюд. Вы получаете возможность попробовать
        несколько видов суши по доступной цене. Поэтому успейте заказать cеты в
        Днепре уже сейчас и наслаждаться ими.
      </Text>
    ),
  },
  {
    page: "Kebab",
    id: 4,
    title1: <Text>Быстрая доставка сочной шаурмы в Днепре</Text>,
    text1: (
      <Text>
        Сочная шаурма в Днепре — топовое блюдо, которое любят украинцы, теперь
        доступна для доставки домой или в офис! Независимо от того, где вы
        находитесь, вы можете насладиться вкусом этого ароматного блюда без
        необходимости выходить из дома или прерывать работу в офисе.
        <br />
        <br /> В Burger Lord у нас есть своя доставка шаурмы, чтобы
        удовлетворить потребности своих клиентов. Вы можете просто выбрать свой
        любимый вид, указать адрес доставки, и мы привезем ближневосточное блюдо
        из мяса прямо к вашей двери.
        <br />
        <br /> Доставка шавермы домой или в офис стала отличным решением для
        занятых людей, которые ценят свое время и комфорт. Теперь вы можете
        насладиться этим популярным блюдом в любое удобное для вас время, не
        отрываясь от дел.
      </Text>
    ),
    title2: <Text>Особенности приготовления донер-кебаб от Burger Lord</Text>,
    text2: (
      <Text>
        1. Качественные ингредиенты: Мы придерживаемся высоких стандартов
        качества. Используем только свежие и натуральные ингредиенты для
        приготовления нашей шаурмы. Мясо отбирается с особой тщательностью,
        овощи свежие и хрустящие, а соусы приготовлены по оригинальным рецептам.{" "}
        <br />
        <br />
        2. Мариновка мяса: Чтобы придать мясу неповторимый вкус, маринуем его в
        специальных смесях приправ. Мясо пропитывается ароматами и становится
        сочным и нежным. <br />
        <br />
        3. Профессиональное жарение: Наши повара имеют богатый опыт в
        приготовлении шаурмы, поэтому каждый кусочек выходит идеально.
        <br />
        <br /> 4. Уникальные соусы: Есть разнообразие соусов, которые подчеркнут
        вкус вашей шаурмы. При приготовлении применяется авторская рецептура,
        позволяющая создавать особенные и уникальные сочетания.
      </Text>
    ),
  },
  {
    page: "Noodles",
    id: 5,
    title1: <Text>Вкуснейшая лапша в коробочках в Днепре</Text>,
    text1: (
      <Text>
        Лапша ВОК — это незабываемое блюдо азиатской кухни, которое завоевало
        сердца многих украинцев. Сочетание свежих овощей, ароматных специй и
        нежной лапши делает его идеальным выбором для любителей вкусной и
        разнообразной пищи. <br />
        <br />
        Это блюдо заказать в Burger Lord с доставкой прямо к вашей двери, что
        делает его ещё более удобным и доступным для получения гастрономического
        удовольствия в любое время. Wok в Днепре отличается своей яркой подачей
        и гармоничным сочетанием различных ингредиентов. Ароматы пряностей,
        соусов и много начинки проникают в каждый кусочек, где играет огромная
        палитра вкусов. <br />
        <br />
        Не упускай возможность попробовать эту восхитительную лапшу ВОК прямо у
        себя дома или в офисе. Закажи вок Днепр с доставкой и наслаждайся
        настоящим вкусом Азии прямо у себя на столе.
      </Text>
    ),
    title2: <Text>Лапша в коробочках: преимущества</Text>,
    text2: (
      <Text>
        Еда в коробочках — это удобное и практичное решение для любителей
        вкусной и быстрой еды. Вот несколько преимуществ, которые делают лапшу
        WOK особенно привлекательными: <br />
        <br />
        1. Разнообразие: Вы можете выбрать различные виды лапши, такие как
        рисовая, пшеничная или яичная, а также различные соусы, от классического
        соевого до острого чили. Кроме того, вы можете добавить необычные
        начинки, чтобы создать идеальное сочетание вкусов. <br />
        <br />
        2. Порционность: Лапша wok предполагает готовые порции, что очень удобно
        для одиночных обедов или перекусов. Вы можете выбрать нужное количество
        коробочек в зависимости от вашего аппетита или количества человек, для
        кого заказываете. Это также помогает избежать излишков и экономит время.{" "}
        <br />
        <br />
        3. Переносимость: Еду в коробочках легко брать с собой. Это отличное
        решение для тех, кто работает в офисе или постоянно находится в
        движении. Вы можете взять коробочку с собой или заказать китайскую лапшу
        непосредственно перед употреблением. <br />
        <br />
        Лапша ВОК — это разнообразное и вкусное решение для тех, кто ценит
        быструю и вкусную еду. Попробуйте лапшу в коробочках и наслаждайтесь
        превосходным азиатским вкусом в любое время и в любом месте!”
      </Text>
    ),
  },
  {
    page: "Soups",
    id: 6,
    title1: <Text>Доставка супа в Днепре</Text>,
    text1: (
      <Text>
        Нет ничего более утоляющего голод и приносящего удовольствие, чем теплый
        и ароматный суп для зимнего и осеннего периода, а в летнее время —
        холодный, тонизирующий и освежающий. Это не только отличный способ
        насытиться, но и улучшить свое самочувствие благодаря ценным питательным
        веществам, которые в нем содержатся. <br />
        <br /> Чтобы насладиться вкусом супа, вам больше не нужно тратить время
        на приготовление или ходить в ресторан. Сегодня есть удобная доставка
        супов от Burger Lord в Днепре, которая позволяет вам заказать свое
        любимое блюдо прямо домой или в офис.
      </Text>
    ),
    title2: <Text>Преимущества доставки</Text>,
    text2: (
      <Text>
        Пользуясь услугой доставки супа, вы получаете ряд преимуществ:
        <br />
        <br /> 1. Экономия времени. Вам больше не нужно беспокоиться о покупке
        ингредиентов, приготовлении и последующей уборке кухни. Просто выберите
        суп нашего меню, оформите заказ и наслаждайтесь своим выбором в удобное
        для вас время.
        <br />
        <br /> 1. Разнообразие выбора. Предлагаем широкий выбор супов: от
        классических рецептов, таких как окрошка, солянка или куриный бульон, до
        экзотических вариантов, например, том-ям кунг или мисо. Вы можете
        выбрать суп, который соответствует вашим предпочтениям и настроению.
        <br />
        <br />
        2. Свежесть и качество. Готовим супы непосредственно перед доставкой,
        чтобы сохранить их свежесть и аромат. Вы можете быть уверены, что суп,
        который вы получите, будет приготовлен из свежих и качественных
        ингредиентов.
        <br />
        <br />
        3. Удобство. Вы можете выбрать удобное для вас время доставки и место,
        где вы хотите получить свой заказ. Больше нет необходимости вставать с
        дивана или прерывать работу в офисе, чтобы поесть вкусный суп. Просто
        подождите, пока суп с доставкой прибудет к вам.
      </Text>
    ),
  },
  {
    page: "Burger",
    id: 7,
    title1: <Text>Вкуснейшие бургеры в Днепре</Text>,
    text1: (
      <Text>
        Бургеры — это безусловно одно из самых популярных блюд во всем мире! Не
        смотря на свое происхождение из Соединенных Штатов, они быстро завоевали
        сердца и желудки людей по всему миру. Сочная говяжья или куриная
        котлета, хрустящая булочка, разнообразные соусы, свежие овощи и сыр —
        все это делает бургеры невероятно аппетитными и сочными.
        <br />
        <br /> И самое лучшее во всей этой истории — возможность заказа бургеров
        с доставкой от Burger Lord! Теперь ты можешь наслаждаться своим любимым
        блюдом в уюте своего дома или в офисе, без необходимости тратить время
        на приготовление или посещение ресторана. У нас своя доставка бургеров в
        Днепре, что делает их еще более доступными и удобными.
        <br />
        <br /> Благодаря широкому разнообразию вариантов и комбинаций
        ингредиентов, каждый может найти бургер по своему вкусу, где будет много
        начинки и огромная палитра вкусов. Также предлагаем варианты, где
        используется авторская рецептура.
        <br />
        <br /> Если ты хочешь насладиться вкусным и сытным блюдом, просто выбери
        свой любимый бургер на дом или в офис от Burger Lord и заказывай его с
        доставкой по Днепру.
      </Text>
    ),
    title2: <Text>Почему бургеры от Burger Lord самые вкусные?</Text>,
    text2: (
      <Text>
        Бургеры от Burger Lord можно назвать одними из самых вкусных! Вот
        несколько причин, почему это так: <br />
        <br />
        1. Качество ингредиентов: Уделяем особое внимание выбору свежих и
        высококачественных ингредиентов. От свежих мясных котлет до сочных
        помидоров, хрустящих овощей и нежного сыра — каждый компонент бургера
        подобран с заботой о качестве и вкусе.
        <br />
        <br />
        2. Разнообразие меню: Предлагаем широкий выбор бургеров, чтобы каждый
        мог найти свой идеальный вариант. Независимо от того, предпочитаешь ли
        ты классические комбинации, необычные начинки или желаешь попробовать
        что-то новое и экзотическое, у нас есть бургеры для любого вкуса. <br />
        <br />
        3. Уникальные рецепты и соусы: Разрабатываем уникальные рецепты
        бургеров, чтобы удивить своих клиентов. Экспериментируем с различными
        сочетаниями ингредиентов и создаем вкусные соусы, которые добавляют
        бургерам неповторимый вкус. <br />
        <br />
        4. Профессионализм и внимание к деталям: Наша команда состоит из опытных
        профессионалов, которые готовят бургеры с любовью и заботой. Уделяем
        внимание каждой детали, чтобы бургер был свежим, сочным и идеально
        приготовленным.
        <br />
        <br /> 5. Удобство доставки: Своя доставка, чтобы вы могли насладиться
        вкусными бургерами прямо у себя дома или в офисе. Благодаря этому вы
        можете получать удовольствие от блюд в любое удобное время. <br />
        <br />
        Бургеры от Burger Lord вкусные, приготовленные по уникальным рецептам
        профессиональной командой.
      </Text>
    ),
  },
  {
    page: "Pizza",
    id: 8,
    title1: <Text>Лучшая пицца в Днепре</Text>,
    text1: (
      <Text>
        Пицца — это одно из самых популярных блюд во всем мире. Она известна
        своим разнообразием ароматных начинок, сочным тестом и неповторимым
        вкусом. Люди заказывают пиццу как для ужина с семьей или друзьями, так и
        для перекуса в офисе. Уже вкусно звучит, не правда ли? Если вы
        находитесь в Украине, то заказать пиццу в Днепре вы можете в считанные
        минуты в заведении Burger Lord.
        <br />
        <br /> Мы предлагаем широкий выбор различных видов и размеров пиццы, где
        вы будет много начинки и огромная палитра вкусов. Кроме того, мы
        постоянно разрабатываем новые сочетания ингредиентов, экспериментируем с
        формой и структурой теста, чтобы создавать уникальные и неповторимые
        вкусовые комбинации.
        <br />
        <br /> Заказать доставку пиццы на дом или в офис вы можете онлайн или по
        указанным номерам.
      </Text>
    ),
    title2: <Text>Ассортимент пиццы, который мы предлагаем</Text>,
    text2: (
      <Text>
        Выбор пиццы от Burger Lord — это разнообразие вкусов и предпочтений,
        удовлетворяющий различные вкусовые предпочтения. У нас есть следующие
        варианты:
        <br />
        <br /> 1. Морская пицца — это истинное наслаждение для любителей
        морепродуктов. Она обычно включает свежие мидии, креветки, кальмары или
        другие морики, сочетающиеся с ароматными травами и специями. Морская
        пицца предлагает богатый морской вкус и текстуры, которые погружают вас
        в атмосферу побережья. <br />
        <br /> 2. Овощная пицца — отличный выбор для вегетарианцев и тех, кто
        предпочитает более легкие и здоровые варианты. Она может содержать
        различные свежие овощи, такие как баклажаны, цуккини, сладкий перец,
        шампиньоны, помидоры и многое другое. <br />
        <br /> 3. Сырная пицца — идеальный выбор для любителей сыра. Она может
        включать в себя различные сорта сыра, такие как моцарелла, пармезан,
        чеддер и другие. Сочетание разных видов сыра создает неповторимый вкус,
        который плавится на тесте и придает пицце нежную и сырную текстуру.{" "}
        <br />
        <br /> 4. Мясная пицца — идеальный выбор для любителей мяса и более
        насыщенных вкусов. Она может включать в себя различные виды мяса, такие
        как говядина, ветчина, пепперони, бекон, колбаски и другие. Сочетание
        разных видов мяса придает пицце богатый вкус и обильное количество
        белка.
        <br />
        <br /> 5. Авторская пицца — это соединение вкуса и мастерства. Нечто
        оригинальное, необычное, что заставляет возбудиться вкусовым рецепторам
        по максимуму.
        <br />
        <br /> Независимо от вида пиццы, каждый из этих вариантов передает свои
        уникальные вкусовые комбинации. Выбирайте свою и заказывайте с доставкой
        по Днепру.
      </Text>
    ),
  },
];
export const PATH_PROPS = [
  {
    type: "pizza",
  },
];
export const DeliverInfo = [
  {
    text: "бесплатная доставка по Днепру",
  },
  {
    text: `минимальный заказ для бесплатной доставки - 400 грн, если заказ 251-399 грн - доставка 50 грн, меньше 250 грн - только самовывоз`,
  },
  {
    text: "при заказе от 599 грн — дарим Pepsi 1 л ❤️",
  },
  {
    text: "при заказе от 999 грн — дарим пиццу Салями, ролл Микс фиш или Pepsi 1 л на ваш выбор 🔥",
  },
  {
    text: "при заказе от 1599 грн — дарим Суши бургер с лососем, пиццу Салями, ролл Микс фиш или Pepsi 1 л на ваш выбор 🔥",
  },
];

export const SocialLink = [
  {
    initial: 40,
    exit: 10,
    top: -50,
    href: "https://t.me/AndreyPervozvaniy",
    icon: FaTelegram,
  },
  {
    initial: 80,
    exit: 40,
    top: -100,
    href: "https://www.instagram.com/andreypervozvaniy?igsh=YndvcDNzOHhtd2E4&utm_source=qr",
    icon: FaInstagram,
  },
  {
    initial: 120,
    exit: 80,
    top: -150,
    href: "https://www.linkedin.com/in/%D0%B0%D0%BD%D0%B4%D1%80%D0%B5%D0%B9-%D0%B1%D0%B5%D0%BB%D0%BE%D0%BA%D1%83%D0%B4%D1%80%D1%8F-24343b168?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
    icon: FaLinkedin,
  },
];
